import React from "react";
import ContactMessageForm from "@/components/site/ContactMessageForm";
import { CONTACT } from "@/data/content";
import { Phone, Mail, Printer, MapPin } from "lucide-react";
import Seo from "@/lib/Seo";

export default function Contact() {
  return (
    <div>
      <Seo
        path="/contact"
        title="Contact — Call, Write, or Apply"
        description="Main 888.275.0098 · Direct 708.668.9012 · Support@SteadyPathFunding.com. Broker callback within 24 hours (Mon–Fri)."
      />
      <section className="pt-40 pb-16 border-b border-black/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-8">
          <div className="col-span-12 md:col-span-8">
            <div className="overline">Contact · Straight line</div>
            <h1 className="mt-6 font-serif text-6xl md:text-8xl leading-[0.92]">
              Call, write, or apply. <em className="italic text-[color:var(--gold)]">All three work</em>.
            </h1>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-12 gap-12">
          <div className="col-span-12 md:col-span-5 space-y-10">
            {[
              { icon: Phone, label: "Main", value: CONTACT.mainPhone, href: `tel:${CONTACT.mainPhone.replaceAll(".", "")}` },
              { icon: Phone, label: "Direct", value: CONTACT.directPhone, href: `tel:${CONTACT.directPhone.replaceAll(".", "")}` },
              { icon: Printer, label: "Fax", value: CONTACT.fax },
              { icon: Mail, label: "Email", value: CONTACT.email, href: `mailto:${CONTACT.email}` },
              { icon: MapPin, label: "Web", value: CONTACT.website },
            ].map((item, i) => {
              const Icon = item.icon;
              return (
                <div key={item.label} className="flex gap-6 border-t border-black/10 pt-6">
                  <div className="w-10 h-10 flex items-center justify-center border border-[color:var(--gold)]/60 text-[color:var(--gold)] shrink-0">
                    <Icon size={16} />
                  </div>
                  <div>
                    <div className="font-mono text-[10px] tracking-[0.24em] uppercase text-[color:var(--bone)]/55">
                      {item.label}
                    </div>
                    {item.href ? (
                      <a href={item.href} className="mt-2 font-serif text-2xl md:text-3xl gold-link">
                        {item.value}
                      </a>
                    ) : (
                      <div className="mt-2 font-serif text-2xl md:text-3xl">{item.value}</div>
                    )}
                  </div>
                </div>
              );
            })}
            <p className="text-sm text-[color:var(--bone)]/60 leading-relaxed pt-6 border-t border-black/10">
              Broker hours: Mon–Fri, 8 AM – 6 PM CT. We reply to every submission
              within 24 hours during business hours (Monday–Friday).
            </p>
          </div>
          <div className="col-span-12 md:col-span-7">
            <ContactMessageForm />
          </div>
        </div>
      </section>
    </div>
  );
}
